var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart__page"},[_c('h1',[_vm._v("Mes Favoris")]),_c('ProductsGrid',{attrs:{"productsArray":_vm.cardArray,"addvisible":false,"removeIsVisible":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }